export const TariffRowLabel = ({ label, children }) => (
  <div
    className={'font-semibold flex items-center h-full px-5 py-2 rounded'}
  >
    {label || children}
  </div>
);
